import { render, staticRenderFns } from "./quotationDetails.vue?vue&type=template&id=45267d1a&scoped=true"
import script from "./quotationDetails.vue?vue&type=script&lang=js"
export * from "./quotationDetails.vue?vue&type=script&lang=js"
import style0 from "./quotationDetails.vue?vue&type=style&index=0&id=45267d1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45267d1a",
  null
  
)

export default component.exports